var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('detalhes-sidebar'),_c('background-image'),_c('v-content',[_c('pab-header'),_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('resumo-toggle'),_c('pab-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }